/* eslint-disable no-underscore-dangle */
import _ from 'underscore';
import $ from 'jquery';
// import { scopeStore } from '@bingads-webui-campaign/global-context-store';

/* Note:
 * The events we fire to adobe omniture are used by the marketing team.
 * We should not break or change the events payload without confirming the changes with them.
 * Marketing Team: Galen Gerling, David Kline
 */

function serializeList(list) {
  return _.chain(list)
    .pairs()
    .map(item => (item[1] ? item[0] : null))
    .compact()
    .value();
}

export function triggerOmnitureEvent(payload) {
  $(document).trigger('pageview', payload);
}

// The marketing team uses adobe omniture to track
export function initPDL(serverContext) {
  // adobe tracking script will use window._PDL to provide info
  window._PDL = window._PDL || {};
  const omniture = serverContext.Omniture || {};

  window._PDL = window._PDL || {};
  window._PDL.market = omniture.Market;
  window._PDL.pageName = omniture.PageNamePDL;
  window._PDL.navLevel1 = omniture.NavLevel1;
  window._PDL.navLevel2 = omniture.NavLevel2;
  window._PDL.accountNumber = omniture.CurrentAccountNumber;
  window._PDL.accountMode = omniture.CurrentAccountMode || omniture.AccountMode;
  window._PDL.customerID = omniture.CustomerID;
  window._PDL.userID = omniture.UserID;
  window._PDL.serverName = omniture.ServerName;

  const permissions = serializeList(serverContext.Permissions);
  const dynamicPermissions = serializeList(serverContext.DynamicPermissions);
  const ccuiPermissions = serializeList(serverContext.CCUIPilots);

  window._PDL.permissions = _.union(
    permissions,
    dynamicPermissions,
    ccuiPermissions
  ).join(',');

  // TODO
  // scopeStore.subscribe(() => {
  //   const { campaignId, adGroupId } = scopeStore.state.scope.values;
  //   window._PDL.campaignID = campaignId;
  //   window._PDL.adGroupID = adGroupId;
  // });

  // if navLevel3 was set before init, fire an event
  if (window._PDL.navLevel3) {
    triggerOmnitureEvent({
      campaignId: window._PDL.campaignID,
      adGroupId: window._PDL.adGroupID,
      navLevel3: window._PDL.navLevel3,
      navLevel3Title: window._PDL.navLevel3Title,
    });
  }
}

export function updatePdlPage(payload) {
  const {
    campaignId,
    adGroupId,
    navLevel3,
    navLevel3Title,
  } = payload;

  window._PDL = window._PDL || {};
  window._PDL.campaignID = campaignId;
  window._PDL.adGroupID = adGroupId;
  window._PDL.navLevel3 = navLevel3;
  window._PDL.navLevel3Title = navLevel3Title;

  // Includes nav + campaign elements, plus any additional custom payload
  triggerOmnitureEvent(payload);
}

export function updatePdlUser(serverContext) {
  const {
    CurrentAccount,
    CurrentUser,
  } = serverContext;

  window._PDL = window._PDL || {};
  window._PDL.accountNumber = CurrentAccount.AccountNumber;
  window._PDL.accountMode = CurrentAccount.AccountMode;
  window._PDL.customerID = CurrentAccount.AdvertiserCustomerID;
  window._PDL.userID = CurrentUser.Id;
}
